import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubSidebarComponent } from './sub-sidebar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MenuModule } from 'primeng/menu';
import { PipesModule } from 'projects/access-control/src/app/Infrastructure/pipes/pipes.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
@NgModule({
	declarations: [SubSidebarComponent],
	exports: [SubSidebarComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatIconModule,
		MenuModule,
		PipesModule,
		InfiniteScrollModule,
	],
})
export class SubSidebarModule {}
